export const HOME = {
    emergentLink: "home-emergent-link",
};

export const NAV = {
    logo: "nav-logo",
    home: "nav-home",
    about: "nav-about",
    products: "nav-products",
    industries: "nav-industries",
    solutions: "nav-solutions",
    sourcing: "nav-sourcing",
    importBusiness: "nav-import-business",
    partner: "nav-partner",
    government: "nav-government",
    resources: "nav-resources",
    ai: "nav-ai",
    consultation: "nav-consultation",
    contact: "nav-contact",
    whatsapp: "nav-whatsapp",
    bookCta: "nav-book-cta",
    mobileToggle: "nav-mobile-toggle",
    languageSelect: "nav-language-select",
};

export const HERO = {
    consultationCta: "hero-consultation-cta",
    sourcingCta: "hero-sourcing-cta",
    supplierCta: "hero-supplier-cta",
};

export const FORMS = {
    contact: {
        name: "contact-name",
        email: "contact-email",
        phone: "contact-phone",
        company: "contact-company",
        country: "contact-country",
        message: "contact-message",
        submit: "contact-submit",
    },
    consultation: {
        name: "consult-name",
        email: "consult-email",
        phone: "consult-phone",
        company: "consult-company",
        country: "consult-country",
        sessionType: "consult-session-type",
        date: "consult-date",
        time: "consult-time",
        topic: "consult-topic",
        notes: "consult-notes",
        submit: "consult-submit",
    },
    sourcing: {
        name: "sourcing-name",
        email: "sourcing-email",
        phone: "sourcing-phone",
        company: "sourcing-company",
        country: "sourcing-country",
        category: "sourcing-category",
        description: "sourcing-description",
        quantity: "sourcing-quantity",
        targetPrice: "sourcing-target-price",
        markets: "sourcing-markets",
        packaging: "sourcing-packaging",
        certifications: "sourcing-certifications",
        privateLabel: "sourcing-private-label",
        timeline: "sourcing-timeline",
        notes: "sourcing-notes",
        submit: "sourcing-submit",
    },
    partner: {
        name: "partner-name",
        email: "partner-email",
        phone: "partner-phone",
        company: "partner-company",
        country: "partner-country",
        type: "partner-type",
        experience: "partner-experience",
        industries: "partner-industries",
        linkedin: "partner-linkedin",
        motivation: "partner-motivation",
        submit: "partner-submit",
    },
    productInquiry: {
        name: "product-inquiry-name",
        email: "product-inquiry-email",
        phone: "product-inquiry-phone",
        company: "product-inquiry-company",
        country: "product-inquiry-country",
        type: "product-inquiry-type",
        quantity: "product-inquiry-quantity",
        message: "product-inquiry-message",
        submit: "product-inquiry-submit",
        sampleBtn: "product-request-sample",
        quoteBtn: "product-request-quote",
        whatsappBtn: "product-whatsapp",
    },
    waitlist: {
        name: "waitlist-name",
        email: "waitlist-email",
        company: "waitlist-company",
        submit: "waitlist-submit",
    },
    newsletter: {
        email: "newsletter-email",
        submit: "newsletter-submit",
    },
};

export const PRODUCTS = {
    card: (slug) => `product-card-${slug}`,
};

export const INDUSTRIES = {
    card: (slug) => `industry-card-${slug}`,
};
